import { FC, useState } from 'react';

import SunshineModal from 'components/_core/SunshineModal';
import { logEvent } from 'features/Analytics/analytics';

import AddClientContactModal from '../../../../../../components/AddClientContactModal';
import { useClientContacts } from '../../../../../../hooks/useClientContacts';
import { useQuoteModals } from '../..';
import ResendWithShineModalBody from './components/Body';

export interface ResendWithShineModalProps {
  quoteId: string;
  clientId: string;
}

const ResendWithShineModal: FC<ResendWithShineModalProps> = ({
  clientId,
  quoteId,
}) => {
  const { hideModal } = useQuoteModals();
  const [isNewContactView, setIsNewContactView] = useState(false);
  const [contactOptions, setContactOptions] = useClientContacts();

  const onShowContact = () => {
    logEvent({
      name: 'Add New Client Contact',
      properties: {
        clientId,
        from: 'QuoteResendModal',
      },
    });

    setIsNewContactView(true);
  };

  const onAddContact = (newContactClientId: string) => {
    setContactOptions((previousContactOptions) => ({
      ...previousContactOptions,
      clientContactIds: [
        ...previousContactOptions.clientContactIds,
        newContactClientId,
      ],
    }));

    setIsNewContactView(false);
  };

  const onSelectContacts = (contacts: string[]) =>
    setContactOptions((previousContactOptions) => ({
      ...previousContactOptions,
      clientContactIds: contacts,
    }));

  return (
    <SunshineModal
      isOpen
      onClose={() => {
        hideModal();
        setIsNewContactView(false);
      }}
    >
      {isNewContactView ? (
        <AddClientContactModal
          clientId={clientId}
          onAdd={onAddContact}
          onBack={() => setIsNewContactView(false)}
        />
      ) : (
        <ResendWithShineModalBody
          clientId={clientId}
          contactOptions={contactOptions}
          hideModal={hideModal}
          onSelectContacts={onSelectContacts}
          onShowContact={onShowContact}
          quoteId={quoteId}
        />
      )}
    </SunshineModal>
  );
};

export default ResendWithShineModal;
